<template>
  <div
    v-if="data !== null"
    class="d-flex flex-wrap mb-1 chart-wrapper bytes-info"
  >
    <template v-for="(field, index) in fields">
      <statistic
        :key="index"
        class="p-1 col-6 col-md-4 col-xl-3 top-fade-in"
        :title="
          isByte(field.text)
            ? formatBytes(field.value).toString()
            : field.value.toLocaleString()
        "
        :subtitle="camelCaseToSentence(field.text)"
        icon="ArrowRight"
      />
    </template>
  </div>
  <paper-simple
    v-else-if="loading"
    class="numbers-loading"
    body-class="d-flex align-items-center"
  >
    <b-spinner variant="primary" />
  </paper-simple>
</template>

<script>
import stringHelpers from '@/mixins/string-helpers'
import helpers from '@/mixins/helpers'
import Statistic from '@/components/statistics/Statistic.vue'

export default {
  name: 'NumbersWidget',
  components: { Statistic },
  mixins: [stringHelpers, helpers],
  props: {
    data: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      byteFields: ['totalFileSizeEncoding', 'totalFileSizeEncoded'],
    }
  },
  computed: {
    fields() {
      return this.data ? this.getObjectOptions(this.data) : []
    },
  },
  methods: {
    isByte(field) {
      return this.byteFields.includes(field)
    },
  },
}
</script>
<style lang="scss" scoped>
.numbers-loading {
  min-height: 160px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
